<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-11 09:48:46
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:40:53
-->
<template>
  <div class="innovative innovative-accufficas" :class="{textj: language != 'en', en: language == 'en'}" ref="accufficas">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accufficas.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="" :src="$t('product.accufficas.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-80">
            <div class="innovative-item-title" v-html="$t('product.accufficas.list[0].title')"></div>
            <div class="p-t-46 p-b-60 textj">
              <p v-for="item, index in $t('product.accufficas.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel accufficas-characteristics" :class="{en: language == 'en'}">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.accufficas.list[1].img')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="language != 'en' ? 'posabs' : ''">
          <div class="innovative-characteristics trans-list wh100">
            <div class="innovative-item-title p-l-15" v-html="$t('product.accufficas.list[1].title')"></div>
            <div class="flex p-t-30">
              <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accufficas.list[1].des')" :key="index" :style="index == 1 ? (language == 'en' ? 'padding: 0 10px' : 'padding: 0 6%;') : ''">
                <div :class="['flex flex_col align_items_center', index == 1 ? 'p-r-40' : '']">
                  <div>
                    <img class="" :src="item.img" alt="" srcset="">
                  </div>
                  <div class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15" v-html="item.title"></div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accufficas.list[1].des')" :key="index" :style="index == 1 ? (language == 'en' ? 'padding: 0 10px' : 'padding: 0 6%;') : ''">
                <div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="language != 'en'" class="accufficas-advantages">
        <div class="innovative-container">
          <div class="innovative-accufficas-m-h trans-list">
            <div class="innovative-item-title p-l-15 fz-22 fontn widauto ilblk p-r-60" style="" v-html="$t('product.accufficas.list[2].title')"></div>
            <div class="flex justify_content_center p-t-60 flex">
              <div class="flex_1 p-r-10">
                <img class="wh100" :src="$t('product.accufficas.list[2].img1')" alt="" srcset="">
              </div>
              <div class="p-l-10 flex_1">
                <img class="wid100" :src="$t('product.accufficas.list[2].img2')" alt="" srcset="">
              </div>
            </div>
            <div class="flex justify_content_center p-t-30">
              <div class="m-h-sign" v-html="$t('product.accufficas.list[2].m_imgDes')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="innovative-wrap-item p-t-50 p-b-50 article">
        <div class="innovative-item-title" v-html="$t('product.accufficas.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accufficas.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      box1: false,
      box2: false,
      box3: false,
      box4: false
    }
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-accufficas {
  .innovative-characteristics {
    padding: 50PX 65PX;
    &.en {
      padding: 30PX 30PX 30PX 65PX;
    }
  }
  .accufficas-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
  }
  .innovative-accufficas-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
    padding: 44PX 65PX;
    font-size: 20PX;
    .m-h-sign {
      background: linear-gradient(90deg, #0556EA 0%, #02C2D0 100%);
      color: #ffffff;
      padding: 10PX 40PX;
    }
  }
}
.pc .en {
  .accufficas-characteristics {
    background-image: url('~@/assets/images/innovate/AccuFFicas/2.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1820PX) {
  .pc.zh .innovative-accufficas {
    .accufficas-characteristics {
      height: 600PX;
    }
  }
}
</style>
